import React from 'react'
import { Outlet } from 'react-router-dom'

const ManageAddEdit = () => {
  return (
    <div>
        <Outlet/>
    </div>
  )
}

export default ManageAddEdit